export const AUTH_CUSTOMIZER = '_auth/index.html';